var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyvideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758078327362,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 50953,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M828.952381 121.904762a73.142857 73.142857 0 0 1 73.142857 73.142857v633.904762a73.142857 73.142857 0 0 1-73.142857 73.142857H195.047619a73.142857 73.142857 0 0 1-73.142857-73.142857V195.047619a73.142857 73.142857 0 0 1 73.142857-73.142857h633.904762z m0 268.190476H195.047619v438.857143h633.904762V390.095238z m-390.095238 59.733333a48.761905 48.761905 0 0 1 24.185905 6.436572l194.31619 111.006476a48.761905 48.761905 0 0 1 0 84.675048l-194.31619 111.030857A48.761905 48.761905 0 0 1 390.095238 720.62781V498.590476a48.761905 48.761905 0 0 1 48.761905-48.761905z m24.380952 90.770286v137.996191l120.758857-68.998096L463.238095 540.623238zM341.333333 195.047619H195.047619v121.904762h146.285714V195.047619z m268.190477 0h-195.04762v121.904762h195.04762V195.047619z m219.428571 0h-146.285714v121.904762h146.285714V195.047619z",
    "p-id": 50954,
    fill: "#07c160"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyvideo);
export default __webpack_public_path__ + "static/media/myvideo.9b6dae86.svg";
export { ForwardRef as ReactComponent };